"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAppState = void 0;
const react_native_1 = require("react-native");
const loadAppState = () => react_native_1.AppState;
exports.loadAppState = loadAppState;
